var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2474 1.16602H8.7474C11.6641 1.16602 12.8307 2.33268 12.8307 5.24935V8.74935C12.8307 11.666 11.6641 12.8327 8.7474 12.8327H5.2474C2.33073 12.8327 1.16406 11.666 1.16406 8.74935V5.24935C1.16406 2.33268 2.33073 1.16602 5.2474 1.16602Z",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.90874L8.81499 5.09375",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24094 6.05023C5.63721 6.05023 5.95843 5.72901 5.95843 5.33274C5.95843 4.93648 5.63721 4.61523 5.24094 4.61523C4.84468 4.61523 4.52344 4.93648 4.52344 5.33274C4.52344 5.72901 4.84468 6.05023 5.24094 6.05023Z",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05343 9.38617C9.44969 9.38617 9.77093 9.06492 9.77093 8.66866C9.77093 8.2724 9.44969 7.95117 9.05343 7.95117C8.65716 7.95117 8.33594 8.2724 8.33594 8.66866C8.33594 9.06492 8.65716 9.38617 9.05343 9.38617Z",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageSquare);
export default __webpack_public_path__ + "static/media/percentage-square.31592100d806f06f6dc24f24d5dee858.svg";
export { ForwardRef as ReactComponent };